/**
 * @file SummaryContainer.js
 * @author Mahek Patel
 * @created 2025-07-14
 * @lastModified 2025-07-29
 * @description Chat container component that displays video chat messages with AI summary overlay.
 *              Handles message rendering, emoji processing, and AI summary display functionality.
 */

/*import { framer-motion } from "motion";*/
import React, { useRef, useEffect, useState, memo, useCallback } from "react";
import { motion } from "motion/react";
import { AnimatePresence } from "motion/react";

const SummaryContainer = ({
  summaryFormat,
  overlayText,
  topics,
  languages,
}) => {
  // ==================== REFS & STATE ====================
  //const chatContainerRef = useRef(null);
  const summaryText = overlayText || "Loading paragraph summary...";
  if (summaryFormat === "none") {
    return null;
  }

  const container = {
    hidden: { opacity: 0 },
    visible: (i = 1) => ({
      opacity: 1,
      transition: { staggerChildren: 0.02, delayChildren: 0.04 * i },
    }),
  };

  const child = {
    visible: {
      opacity: 1,
      y: 0,
    },
    hidden: {
      opacity: 0,
      y: 5,
    },
  };

  const AnimateParagraph = ({ summary }) => {
    const loading = summary === "Loading paragraph summary...";

    console.log("RE RENDERING");
    return (
      <motion.p
        key={summary}
        variants={container}
        initial={loading ? "visible" : "hidden"}
        animate="visible"
        className="w-full text-gray-300 tracking-tight whitespace-normal"
        style={{ fontSize: "14.5px" }}
      >
        {summary.split("").map((char, index) => (
          <motion.span key={`${index}-summary`} variants={child}>
            {char}
          </motion.span>
        ))}
      </motion.p>
    );
  };

  // ==================== AI OVERLAY COMPONENT ====================

  // ==================== ANIMATION TO PARAGRAPH SUMMARY ====================
  {
    /*const AnimateParagraphSummary = ({paragraphSummary}) => {
    const [displayedText, setDisplayedText] = useState("");
    const summary = paragraphSummary || "Loading paragraph summary....";
    const lastRef = useRef("");

    useEffect(() => {
      if (lastRef.current === summary) {
        return;
      }
      lastRef.current = summary;
      setDisplayedText("");
      const typingInterval = setInterval(() => {
        setDisplayedText((prev) => {
          if(prev.length < summary.length){
            return summary.slice(0, prev.length + 1);
          } else {
            clearInterval(typingInterval);
            return prev;
          }
        });
      }, 15);
      return () => clearInterval(typingInterval);
    }, [summary]);
    const words = summary.split(" ");
    const shortText = words.slice(0,2).join(" ");
    const diplaySummary = isPlaying ? shortText : summary;

    useEffect (() => {
      let currentId = 0;
      setDisplayedText("");
      const typingInterval = setInterval(() => {
        setDisplayedText((prev) => {
          if(currentId < displaySummary.length){
            const nextText = displaySummary.slice(0, currentId + 1);
            currentId++;
            return nextText;
          } else {
            clearInterval(typingInterval);
            return prev;
          }
        });
      }, 20);
      return () => clearInterval(typingInterval);
    }, [displaySummary]);
    return(
    <p className="w-full text-gray-300 tracking-tight whitespace-normal" style={{ fontSize: "14.5px" }}>
      {displayedText}
      <span className="inline-block w-[2px] h-[14px] bg-white ml-1 animate-pulse" />
    </p>
    );
  };*/
  }

  // ==================== CONSTANTS ====================
  //const shouldShowAIButton = summaryFormat !== "none";

  // ==================== MAIN RENDER ====================
  return (
    <div className="w-full h-full max-h-[700px] space-y-4 text-white pl-2">
      {summaryFormat === "paragraph" ? (
        <div>
          <h3
            className="text-md font-semibold mb-2"
            style={{ fontSize: "15px" }}
          >
            Paragraph Summary:
          </h3>
          {/*<p className="w-full text-gray-300 tracking-tight whitespace-normal" style={{ fontSize: "14.5px" }}>
              {paragraphSummary || overlayText || "Loading paragraph summary..."}
            </p>*/}
          {/*<AnimatePresence mode="wait"> 
              <motion.p key={paragraphSummary || overlayText} className="w-full text-gray-300 tracking-tight whitespace-normal" syle={{fontSize: "14.5px"}}>
                {(paragraphSummary || overlayText || "Loading paragraph summary...").split("").map((char, index) => (
                  <motion.span key={'${char}-${index}'} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{duration: 0.1, delay: index * 0.01, }}>
                    {char}
                  </motion.span>
                ))}
              </motion.p>
            </AnimatePresence>*/}
          {/*<motion.p key={paragraphSummary || overlayText} variants={container} initial="hidden" animate="visible" className="w-full text-gray-300 tracking-tight whitespace-normal" style={{ fontSize: "14.5px" }}>
              {paragraphSummary || overlayText.split("").map((char, index) => (
              <motion.span key={`${paragraphSummary || overlayText}-${index}`} variants={child}>
                {char}
              </motion.span>
              ))}
            </motion.p>*/}
          {/*<motion.p w-full key={paragraphSummary} initial={{ clipPath: "inset(0 100% 0 0)" }} animate={{ clipPath: "inset(0 0% 0 0)" }} transition={{ duration: 2, ease: "linear" }} className="w-full text-gray-300">
              {paragraphSummary}
            </motion.p>*/}
          <AnimateParagraph summary={summaryText} />
        </div>
      ) : summaryFormat === "bullet" ? (
        <div>
          {/*<h3 className="text-md font-semibold mb-2">
              Live Summary:
            </h3>*/}
          <div className="flex gap-8 mt-4">
            {/* Topics Section */}
            <div className="flex-[2] pr-0">
              <h4
                className="text-sm font-semibold mb-3 py-0 px--2"
                style={{ fontSize: "15px" }}
              >
                Topics:
              </h4>
              {topics && topics.length > 0 ? (
                <div className="space-y-2">
                  {topics.map((topic, index) => (
                    <div
                      key={`topic-${index}-${topic.label}`}
                      className="w-full flex items-center gap-2"
                    >
                      <span className="text-lg">{topic.emoji}</span>
                      <span
                        className="text-sm text-gray-300"
                        style={{ fontSize: "14.5px", whiteSpace: "normal" }}
                      >
                        {topic.label}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400">Loading topics...</p>
              )}
            </div>

            {/* Languages Section */}

            {/*<div className="flex-1 max-h-[500px] overflow-y-scroll pr-4">
                <h4 className="text-sm font-semibold mb-2">Languages:</h4>
                {languages && languages.length > 0 ? (
                  <div className="space-y-2">
                    {languages.map((language, index) => (
                      <div key={`lang-${index}-${language.label}`} className="flex items-center gap-2">
                        <span className="text-lg">{language.emoji}</span>
                        <span className="text-sm text-gray-300">
                          {language.label}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-400">Loading languages...</p>
                )}
              </div>*/}
          </div>
        </div>
      ) : (
        <div>
          <p className="text-sm text-gray-400">
            Unknown summary format: {summaryFormat}
          </p>
        </div>
      )}
    </div>
  );
};

{
  /*<div className="switchable-chat-container">
      <div className="desktop:w-[25vw] desktop:h-[85vh] xl:w-[400px] xl:h-[600px] lg:w-[350px] lg:h-[500px] md:w-[300px] md:h-[450px] w-[280px] h-[400px]">
        <div className="chat-content flex-grow mt-6 h-[90%] md:h-[80%]">
          <div className="w-full h-[500px] bg-neutral relative text-white overflow-hidden rounded-md">*/
}
{
  /* AI Summary Overlay Panel */
}
{
  /*{shouldShowAIButton && (
              <div
                className={`absolute top-0 left-0 right-0 z-50 transition-all duration-500 ease-in-out ${
                  showSummary
                    ? "max-h-64 opacity-100 py-3 px-4"
                    : "max-h-0 opacity-0 py-3 px-4"
                } overflow-hidden`}
              >
                <div className="flex justify-between items-start">
                  <SummaryOverlay />
                  <button
                    onClick={() => setShowSummary(false)}
                    className="ml-4 px-3 text-white hover:text-red-400 text-2xl font-bold"
                    title="Close Summary"
                  >
                    ×
                  </button>
                </div>
              </div>
            )}*/
}

{
  /* Show Summary Button */
}
{
  /* Manual test button for debugging */
}
{
  /*{!showSummary && shouldShowAIButton && (
              <div className="absolute top-2 right-4 z-40 flex gap-2">
                
                {updateOverlayText && (
                  <button
                    onClick={() => updateOverlayText("manual-test")}
                    className="text-white text-sm px-2 py-1 bg-blue-600 hover:bg-blue-700 rounded"
                    title="Test AI Update"
                  >
                    Test AI
                  </button>
                )}
                <button
  onClick={() => setShowSummary(true)}
  className="btn btn-sm rounded-full shadow-md hover:shadow-lg transition-all bg-blue-500 hover:bg-blue-600 border-none text-white"
  title="Show AI Summary"
>
  <span className="hidden md:inline">AI Details</span>
  <span className="md:hidden">AI</span>
</button>
              </div>
            )}*/
}

{
  /* Chat Messages Container */
}
{
  /*<div>
              className={`transition-all duration-500 ease-in-out relative w-full overflow-hidden rounded-t-none rounded-b-lg ${
                showSummary && shouldShowAIButton
                  ? "mt-64 h-[calc(100%-16rem)]"
                  : "h-full"
              }`}*/
}
{
  /*<div className="h-full bg-white text-black">
                <div className="p-3 border-b border-gray-200 bg-gray-50">
                  <div className="flex items-center justify-between">
                    <h3 className="font-semibold text-gray-900 text-sm">
                      Video Chat
                    </h3>
                    
                  </div>
                </div>

                <div
                  ref={chatContainerRef}
                  className="h-[calc(100%-50px)] overflow-y-scroll p-3 space-y-2"
                >
                  {displayedMessages &&
                    displayedMessages.map((message, index) => (
                      <div
                        key={message.message_id || index}
                        className="flex items-start gap-2"
                      >
                        {message.author?.images &&
                          message.author.images.length > 0 && (
                            <img
                              src={
                                message.author.images.find(
                                  (img) => img.id === "32x32",
                                )?.url || message.author.images[0]?.url
                              }
                              alt={message.author?.name || "User avatar"}
                              className="w-6 h-6 rounded-full flex-shrink-0"
                            />
                          )}

                        <div className="flex-1 min-w-0">
                          <div className="flex items-baseline gap-2">
                            <span className="font-semibold text-sm text-gray-900">
                              {message.author?.name || "User"}
                            </span>
                            <span className="text-xs text-gray-500">
                              {message.time_text}
                            </span>
                          </div>

                          <div
                            className="text-sm text-gray-900 break-words"
                            dangerouslySetInnerHTML={{
                              __html: processMessageEmojis(
                                message.message,
                                message.emotes,
                              ),
                            }}
                          />
                        </div>
                      </div>
                    ))}

                  {(!displayedMessages || displayedMessages.length === 0) && (
                    <div className="text-center text-gray-500 text-sm mt-8">
                      Chat will appear here during playback
                    </div>
                  )}
                </div>
              </div>*/
}
{
  /*</div>
          </div>
        </div>
      </div>
    </div>*/
}

export default memo(SummaryContainer);
